  <div [formGroup]="attributesFormGroup" class="attribute-group">
    <sc-flex vertical stretchContent>
      <ng-container *ngFor="let attribute of attributeGroup.attributes">
          <sc-content-spacer vertical></sc-content-spacer>
          <mat-form-field appearance="fill" *ngIf="'STRING' == attribute.type">
              <mat-label><app-dictionary-entry-label [model]="attribute.name"></app-dictionary-entry-label></mat-label>
              <input matInput [formControlName]="'attribute_'+attribute.id" [required]="attribute.mandatory === true">
          </mat-form-field>
          <mat-form-field appearance="fill" *ngIf="'TEXT' == attribute.type">
              <mat-label><app-dictionary-entry-label [model]="attribute.name"></app-dictionary-entry-label></mat-label>
              <input matInput [formControlName]="'attribute_'+attribute.id" [required]="attribute.mandatory === true">
          </mat-form-field>
          <mat-form-field appearance="fill" *ngIf="'NUMBER' == attribute.type">
              <mat-label><app-dictionary-entry-label [model]="attribute.name"></app-dictionary-entry-label></mat-label>
              <input matInput numberInput [scale]="0" [formControlName]="'attribute_'+attribute.id" [required]="attribute.mandatory === true">
          </mat-form-field>
          <mat-form-field appearance="fill" *ngIf="'DECIMAL' == attribute.type">
            <mat-label><app-dictionary-entry-label [model]="attribute.name"></app-dictionary-entry-label></mat-label>
            <input matInput numberInput [scale]="3" [formControlName]="'attribute_'+attribute.id" [required]="attribute.mandatory === true">
        </mat-form-field>
          <mat-form-field appearance="fill" *ngIf="'LOOKUP' == attribute.type">
              <mat-label><app-dictionary-entry-label [model]="attribute.name"></app-dictionary-entry-label></mat-label>
              <mat-select  [formControlName]="'attribute_'+attribute.id" [required]="attribute.mandatory === true">
                  <mat-option *ngFor="let value of attribute.values"
                      [value]="value.id+''">
                      {{ value.value }}
                  </mat-option>
              </mat-select>
          </mat-form-field>
          <mat-checkbox *ngIf="'BOOLEAN' == attribute.type" [formControlName]="'attribute_'+attribute.id" [required]="attribute.mandatory === true">
            <app-dictionary-entry-label [model]="attribute.name"></app-dictionary-entry-label>
          </mat-checkbox>
      </ng-container>
  </sc-flex>
</div>
